import { COMPONENT_KEY } from '@web-platform/shared-universal-constants/src/componentKeys';

import type { PlacesResponseBody } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarExplore';
import type { BucketedLocationsResponse } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarUnfocusedSearch';
import type { Vibe } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedExplore/placeResults';

const { countryDestination, countryOrigin, everywhereDestination } = COMPONENT_KEY;

// Helper to extract the bucketed‐locations section from the Radar response.
// Only cares about “everywhere” → “country” → “origin” searches.
function getBucketedResponse(response: PlacesResponseBody): BucketedLocationsResponse | null {
  if (everywhereDestination in response) {
    return response.everywhereDestination;
  }
  if (countryDestination in response) {
    return response.countryDestination;
  }
  if (countryOrigin in response) {
    return response.countryOrigin;
  }
  return null;
}

// Build a reverse lookup map from each numeric placeId → list of vibe IDs.
export function invertVibes(response: PlacesResponseBody): Record<string, Vibe[]> {
  const map: Record<string, Vibe[]> = {};
  const buckets =
    getBucketedResponse(response)?.buckets.filter((bucket) => bucket?.category === 'VIBES') ?? [];

  buckets.forEach(({ id, label, resultIds = [] }) => {
    resultIds.forEach((resultId) => {
      const match = /^location-(\d+)$/.exec(resultId);
      if (!match) return;

      const numericId = match[1];
      map[numericId] ||= [];
      map[numericId].push({ label, id });
    });
  });

  return map;
}
